import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class EditorErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <s-page heading="Editor error">
          <s-section accessibilityLabel="Error en el editor">
            <s-banner tone="critical">
              <s-stack direction="block" gap="base">
                <s-text type="strong">Something went wrong</s-text>

                <s-text>The editor encountered an unexpected error.</s-text>

                {this.state.error?.message && (
                  <s-box
                    background="base"
                    padding="small"
                    borderRadius="small-100"
                    border="small subdued solid"
                    overflow="hidden"
                  >
                    <s-text>{this.state.error.message}</s-text>
                  </s-box>
                )}

                <s-button
                  variant="primary"
                  tone="critical"
                  onClick={() => {
                    this.setState({ hasError: false, error: null });
                    window.location.reload();
                  }}
                >
                  Reload editor
                </s-button>
              </s-stack>
            </s-banner>
          </s-section>
        </s-page>
      );
    }

    return this.props.children;
  }
}
